import React from 'react'

export const northDakotaSetupVars = {
  siteId: 'north_dakota',
  pathPrefix: '/nd',
  menuHeader: "Discover North Dakota's Solution for:",
  appUrl: 'https://nd.headed2.com',
  logoImg: '/images/assets/north_dakota/horizontal/dark.svg',
  headerTitle: `The North Dakota CareerExplorer is a system designed for North Dakota`
}
